const collapsiblePanel = (refPanel, panelIsOpened, isMobile, styles) => {
  const panel = refPanel?.current;

  if (panel) {
    if (!isMobile) {
      if (panel.style) {
        panel.style.maxHeight = panelIsOpened ? `${panel.scrollHeight}px` : null;
      }
    } else if (panelIsOpened) {
      panel.classList.add(styles.mobile_panel_opened);
    } else {
      panel.classList?.remove(styles.mobile_panel_opened);
    }
  }
};

export default collapsiblePanel;
